export const ACTIVE_TAB_FRIENDS = 'FRIENDS';
export const ACTIVE_TAB_GLOBAL = 'GLOBAL';
export const ACTIVITY_PREFERENCE = 'READNG_ACTIVITY_PREFERENCE';
